// Stop measuring for now
// import { EmbeddedMetricsLogger } from '@eventbrite/openapi-service';

// export const metrics = new EmbeddedMetricsLogger('HomepageWebapp');

export const metrics = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    measure: async (fn: () => Promise<any>, _name: string, _params: Record<string, string>) => {
        return await fn();
    },
};
